import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  step: 0,
  id: null,
  type: null,
  agencySource: null,
  agencyTarget: null,
  labelAgency: null,
  dateStart: null,
  dateEnd: null,
  hourStart: 16,
  hourEnd: 10,
  product: null,
  insurance: null,
  options: null,
  activities: null,
  customer: null,
  discount: {
    percent: false,
    discount: 0,
  },
  promoCode: null,
  drivers: [],
  price: null,
  loadingPrice: false,
  productEventId: null,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBooking: (state, action) => {
      return {
        ...initialState,
        agencySource: action.payload.agencySource,
        agencyTarget: action.payload.agencyTarget,
        labelAgency: action.payload.labelAgency,
        type: action.payload.type,
        dateStart: action.payload.dateStart,
        dateEnd: action.payload.dateEnd,
        ByDateProduct: action.payload.ByDateProduct || null,
        ByProductAgency: action.payload.ByProductAgency || null,
      };
    },
    setNewBooking: (state, action) => {
      return {
        ...initialState,
        agencySource: action.payload.agencySource,
        agencyTarget: action.payload.agencyTarget,
        labelAgency: action.payload.labelAgency,
        type: action.payload.type,
        dateStart: action.payload.dateStart,
        dateEnd: action.payload.dateEnd,
      };
    },
    setAgency: (state, action) => {
      (state.agencySource = action.payload.agencySource),
        (state.agencyTarget = action.payload.agencyTarget),
        (state.labelAgency = action.payload.labelAgency),
        (state.type = action.payload.type),
        (state.dateStart = action.payload.dateStart),
        (state.dateEnd = action.payload.dateEnd);
    },
    setProduct: (state, action) => {
      state.product = action.payload.product;
    },
    setOptionsBooking: (state, action) => {
      state.options = action.payload.options;
    },
    setActivitiesBooking: (state, action) => {
      state.activities = action.payload.activities;
    },
    setInsuranceBooking: (state, action) => {
      state.insurance = action.payload.insurance;
    },
    setCustomerBooking: (state, action) => {
      state.customer = action.payload.customer;
    },
    setDiscountBooking: (state, action) => {
      state.discount = action.payload;
    },
    setDrivers: (state, action) => {
      state.drivers.push(action.payload);
    },
    deleteDriver: (state, action) => {
      state.drivers = state.drivers.filter(
        (driver, index) => index !== action.payload,
      );
    },
    setTotal: (state, action) => {
      state.price = action.payload;
    },
    setPromoCode: (state, action) => {
      state.promoCode = action.payload;
    },
    setId: (state, action) => {
      state.id = action.payload.id;
    },
    setStep: (state, action) => {
      state.step = action.payload.step;
    },
    setLoadingPrice: (state, action) => {
      state.loadingPrice = action.payload;
    },
    setHours: (state, action) => {
      state.hourStart = action.payload.hourStart;
      state.hourEnd = action.payload.hourEnd;
    },
    setProductEventId: (state, action) => {
      state.productEventId = action.payload.productEventId;
    },
    setDeleteEventId: (state, action) => {
      state.productEventId = null;
    },
    deleteBooking: () => initialState,
  },
});

export const {
  setBooking,
  setNewBooking,
  deleteBooking,
  setStep,
  setAgency,
  setDeleteEventId,
  setProduct,
  setOptionsBooking,
  setInsuranceBooking,
  setCustomerBooking,
  setDiscountBooking,
  setDrivers,
  setTotal,
  setPromoCode,
  setId,
  deleteDriver,
  setActivitiesBooking,
  setLoadingPrice,
  setHours,
  setProductEventId,
} = bookingSlice.actions;

export default bookingSlice.reducer;
